module.exports = __webpack_public_path__ + "src/assets/img/checkMark.271c8407.svg";